import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {WelfareResultService} from '../../../../core/service/welfare-result.service';
import {WelfareProjectResult} from '../../../../core/class/result/welfare-project-result';
import {IncomeResultComponent} from '../../../../core/components/result/income-result/income-result.component';
import {AssetResultComponent} from '../../../../core/components/result/asset-result/asset-result.component';
import {DebtsResultComponent} from '../../../../core/components/result/debts-result/debts-result.component';
import {LifeProjectResultComponent} from '../../../../core/components/result/life-project-result/life-project-result.component';
import {SafeguardComponent} from '../../../../core/components/result/safeguard/safeguard.component';
import {BaseResultComponent} from '../../../../core/components/result/base-result/base-result.component';
import {WelfareChartComponent} from '../../../../core/components/result/charts/welfare-chart/welfare-chart.component';
import {WelfarePipeChartComponent} from '../../../../core/components/result/charts/welfare-pipe-chart/welfare-pipe-chart.component';
import {IncomeRepartitionComponent} from '../../../../core/components/result/income-repartition/income-repartition.component';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit, AfterViewInit {

  @ViewChild('assetStatus')
  private assetStatus: WelfareChartComponent;

  @ViewChild('familyIncomeResult')
  private incomeResult: IncomeResultComponent;

  @ViewChild('assetResult')
  private assetResult: AssetResultComponent;

  @ViewChild('debtResult')
  private debtResult: DebtsResultComponent;

  @ViewChild('economicCount')
  private economicCount: WelfareChartComponent;

  @ViewChild('lifeProject')
  private lifeProject: LifeProjectResultComponent;

  @ViewChild('safeGuard')
  private safegurad: SafeguardComponent;

  @ViewChild('economicCountPreview')
  private economicCountPreview: WelfareChartComponent;

  @ViewChild('assetStatusPreview')
  private assetStatusPreview: WelfareChartComponent;

  @ViewChild('assetPipePreview')
  private assetPipePreview: WelfarePipeChartComponent;

  @ViewChild('incomeRepartition')
  private incomeRepartition: IncomeRepartitionComponent;

  @Input()
  private welfareProjectResult: WelfareProjectResult;
  private resutlsComponets: BaseResultComponent[] = [];

  constructor(private api: ApiService, private welfareProject: WelfareResultService) {
  }

  ngOnInit() {
  }

  isAssetResult() {
    let ret = false;

    if (this.welfareProjectResult) {
      const assetResult = this.welfareProjectResult.assetResult;
      if (assetResult) {
        const asset = assetResult.assets;
        if (asset) {
          ret = asset.length > 0;
        }
      }
    }

    return ret;
  }

  isDebtResult() {
    let ret = false;

    if (this.welfareProjectResult) {
      const debtResult = this.welfareProjectResult.debtResult;
      if (debtResult) {
        const debts = debtResult.debts;
        if (debts) {
          ret = debts.length > 0;
        }
      }
    }

    return ret;
  }

  private compute() {
    if (this.welfareProjectResult) {
      this.incomeResult.familyIncomeResult = this.welfareProjectResult.familyIncomeResult;
      this.incomeResult.desktop = this.welfareProjectResult.desktop;
      this.assetResult.assetResult = this.welfareProjectResult.assetResult;
      this.debtResult.debtResult = this.welfareProjectResult.debtResult;
      this.economicCount.linearChartResult = this.welfareProjectResult.economicCount;
      this.assetStatus.linearChartResult = this.welfareProjectResult.assetStatus;
      this.lifeProject.lifeProjectResult = this.welfareProjectResult.lifeProjects;
      this.safegurad.safeguard = this.welfareProjectResult.safeguardResult;
      this.safegurad.pipeResult = this.welfareProjectResult.annualIncome;
      this.safegurad.incomeResult = this.welfareProjectResult.familyIncomeResult;

      const isLifeProject = this.welfareProjectResult.lifeProjects.lifeProjects.length > 0;

      if (isLifeProject) {
        this.economicCountPreview.linearChartResult = this.welfareProjectResult.economicCountPreview;
        this.assetStatusPreview.linearChartResult = this.welfareProjectResult.assetStatusPreview;
        this.assetPipePreview.pipeChartResult = this.welfareProjectResult.assetPipePreview;
        this.incomeRepartition.pipeResult = this.welfareProjectResult.annualIncome;
        this.incomeRepartition.incomeResult = this.welfareProjectResult.familyIncomeResult;
      }

      this.economicCountPreview.hide = !isLifeProject;
      this.assetStatusPreview.hide = !isLifeProject;
      this.assetPipePreview.hide = !isLifeProject;
      this.incomeRepartition.hide = !isLifeProject;

      this.resutlsComponets.forEach(comp => comp.OnResult());
    }
  }

  public computeResult() {

    this.welfareProjectResult = this.welfareProject.projectResult;

    if (!this.welfareProjectResult) {
      this.api.getProjectResult(this.welfareProject.welfareProject).subscribe(value => {
        this.welfareProjectResult = value;
        this.welfareProject.projectResult = value;
        this.compute();
      });
    } else {
      this.compute();
    }
  }

  computeOnlineResult() {
    this.api.getProjectResult(this.welfareProject.welfareProject).subscribe(value => {
      this.welfareProjectResult = value;
      this.welfareProject.projectResult = value;
      this.compute();
    });
  }

  ngAfterViewInit(): void {
    this.resutlsComponets.push(this.incomeResult);
    this.resutlsComponets.push(this.assetResult);
    this.resutlsComponets.push(this.debtResult);
    this.resutlsComponets.push(this.economicCount);
    this.resutlsComponets.push(this.assetStatus);
    this.resutlsComponets.push(this.lifeProject);
    this.resutlsComponets.push(this.safegurad);
    this.resutlsComponets.push(this.economicCountPreview);
    this.resutlsComponets.push(this.assetStatusPreview);
    this.resutlsComponets.push(this.assetPipePreview);
    this.resutlsComponets.push(this.incomeRepartition);

    if (this.welfareProjectResult) {
      this.compute();
    }
  }

  isLifeProjectStepVisible(): boolean {
    if (this.welfareProjectResult && this.welfareProjectResult.lifeProjects) {
      return this.welfareProjectResult.lifeProjects.lifeProjects.length > 0;
    }
    return false;
  }
}


